'use client';

import React, { useEffect, useRef, useState } from 'react';
import { AutoComplete, Spin, Tag } from 'antd';
import { debounce } from 'lodash';
import { axius, types } from '../utils';

const SearchableMultiSelect = (props) => {
	const { value = [], onChange } = props;
	const [inputValue, setInputValue] = useState('');
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);

	const fetchUsers = (searchText) => {
		setLoading(true);
		axius
			.get('users', {
				name: searchText,
				type: types.UserTypes.AARIN,
				status: 'ACTIVE',
				cursor: '0-6',
			})
			.then((response) => {
				const selectedUuids = value.map((item) => item.id);
				const users = response.data
					.filter((user) => !selectedUuids.includes(user.id))
					.map((user) => ({
						value: user.id,
						label: user.name,
						data: {
							id: user.id,
							email: user.email || '',
							name: user.name,
						},
					}));
				setOptions(users);
			})
			.catch(() => setOptions([]))
			.finally(() => setLoading(false));
	};

	const debouncedFetchUsers = useRef(debounce(fetchUsers, 300)).current;
	useEffect(() => {
		if (inputValue) {
			debouncedFetchUsers(inputValue);
		} else {
			setOptions([]);
		}
	}, [inputValue, debouncedFetchUsers]);

	const handleSelect = (uuid, option) => {
		const newSelectedItems = [...value, option.data];
		onChange?.(newSelectedItems);
		setInputValue('');
	};

	const handleRemoveItem = (id) => {
		const newSelectedItems = value.filter((item) => item.id !== id);
		onChange?.(newSelectedItems);
	};

	const handleSearch = (value) => {
		setInputValue(value);
	};

	return (
		<div className="w-100 bg-light">
			<div
				className="flex flex-wrap gap-2"
				style={{ maxHeight: '250px', overflow: 'scroll' }}
			>
				{value.map((item) => (
					<Tag
						key={item.id}
						closable
						onClose={() => handleRemoveItem(item.id)}
						className="bg-blue-100 text-blue-800"
					>
						{item.name || ''}
					</Tag>
				))}
			</div>
			<AutoComplete
				options={options}
				onSearch={handleSearch}
				onSelect={handleSelect}
				placeholder={value.length ? 'Add more...' : 'Search users...'}
				style={{ width: '100%' }}
				value={inputValue}
				allowClear
				notFoundContent={loading ? <Spin size="small" /> : null}
			/>
		</div>
	);
};

export default SearchableMultiSelect;
